import { useJoinAppointment } from "./useJoinAppointment";

export const withJoinAppointment = (Component) => {
  return (props) => {
    const { joinAppointment, getVideoUrl, hasNewVideoExp, isLoading } = useJoinAppointment();

    return (
      <Component
        {...props}
        joinAppointment={joinAppointment}
        getVideoUrl={getVideoUrl}
        hasNewVideoExp={hasNewVideoExp}
        isJoinAppointmentLoading={isLoading}
      />
    );
  };
};
